"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _withStyles = _interopRequireDefault(require("../withStyles"));

var _classnames = _interopRequireDefault(require("classnames"));

var _downshift = _interopRequireDefault(require("downshift"));

var _get = _interopRequireDefault(require("lodash/get"));

var _Scaffold = _interopRequireDefault(require("../Scaffold"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var itemToString = function itemToString(item) {
  return item ? item.label : "";
};
/**
 * A component that renders styled select inputs for use in forms.
 */


var Select =
/*#__PURE__*/
function (_Component) {
  _inherits(Select, _Component);

  function Select(props) {
    var _this;

    _classCallCheck(this, Select);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Select).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "_input", void 0);

    _defineProperty(_assertThisInitialized(_this), "_inputWrapper", void 0);

    _defineProperty(_assertThisInitialized(_this), "handleStateChange", function (changes, downshiftStateAndHelpers) {
      if (!downshiftStateAndHelpers.isOpen) {
        _this.setState({
          inputValue: ""
        });
      }

      if (changes.hasOwnProperty("selectedItem")) {
        _this.onItemSelect(changes.selectedItem);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onInputChange", function (e) {
      var inputValue = e.target.value;

      _this.setState({
        inputValue: inputValue
      });

      if (_this.props.onSearch) {
        _this.props.onSearch({
          inputValue: inputValue,
          originalItems: _this.props.items,
          currentItems: _this.state.items,
          setItems: _this.setItems
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onItemSelect", function (item) {
      var _this$props = _this.props,
          name = _this$props.field.name,
          setFieldValue = _this$props.form.setFieldValue;
      setFieldValue(name, item.value);
    });

    _defineProperty(_assertThisInitialized(_this), "onWrapperClick", function (e) {
      e.stopPropagation();
      e.preventDefault();

      _this.focusOnInput();
    });

    _defineProperty(_assertThisInitialized(_this), "inputRef", function (c) {
      _this._input = c;
    });

    _defineProperty(_assertThisInitialized(_this), "inputWrapperRef", function (c) {
      _this._inputWrapper = c;
    });

    _defineProperty(_assertThisInitialized(_this), "setItems", function (items) {
      if (!(items && Array.isArray(items))) {
        return;
      }

      _this.setState({
        items: items
      });
    });

    _this.state = {
      inputValue: "",
      items: props.items || []
    };
    return _this;
  }

  _createClass(Select, [{
    key: "focusOnInput",
    value: function focusOnInput() {
      this._input.focus();

      if (typeof this._input.getInput === "function") {
        this._input.getInput().focus();
      }
    }
  }, {
    key: "renderTimesIcon",
    value: function renderTimesIcon(onItemSelect) {
      var _this$props2 = this.props,
          classes = _this$props2.classes,
          colors = _this$props2.theme.colors;
      return _react["default"].createElement("button", {
        onClick: function onClick() {
          return onItemSelect({
            label: "",
            value: ""
          });
        },
        type: "button",
        className: classes.arrow,
        title: "Clear item(s)"
      }, _react["default"].createElement("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24"
      }, _react["default"].createElement("path", {
        fill: colors.error || "currentColor",
        d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
      })));
    }
  }, {
    key: "renderArrowIcon",
    value: function renderArrowIcon(isOpen) {
      var _this$props3 = this.props,
          classes = _this$props3.classes,
          colors = _this$props3.theme.colors;
      return _react["default"].createElement("button", {
        type: "button",
        className: classes.arrow,
        title: "Expand dropdown"
      }, _react["default"].createElement("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 1792 1792",
        transform: isOpen ? "rotate(180)" : null
      }, _react["default"].createElement("path", {
        fill: colors.gray300 || "currentColor",
        d: "M1395 736q0 13-10 23l-466 466q-10 10-23 10t-23-10l-466-466q-10-10-10-23t10-23l50-50q10-10 23-10t23 10l393 393 393-393q10-10 23-10t23 10l50 50q10 10 10 23z"
      })));
    }
    /**
     * Used by onSearch to change the dropdown items that exist
     * @param {*} items
     */

  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props4 = this.props,
          classes = _this$props4.classes,
          className = _this$props4.className,
          _this$props4$field = _this$props4.field,
          name = _this$props4$field.name,
          value = _this$props4$field.value,
          _this$props4$form = _this$props4.form,
          errors = _this$props4$form.errors,
          setFieldTouched = _this$props4$form.setFieldTouched,
          touched = _this$props4$form.touched,
          label = _this$props4.label,
          _this$props4$withScaf = _this$props4.withScaffold,
          withScaffold = _this$props4$withScaf === void 0 ? true : _this$props4$withScaf,
          inputProps = _this$props4.inputProps;
      var _this$state = this.state,
          inputValue = _this$state.inputValue,
          items = _this$state.items;
      var selectedItem = items.find(function (item) {
        return item.value === value;
      }) || {
        label: "",
        value: ""
      };
      return _react["default"].createElement(_downshift["default"], {
        itemToString: itemToString,
        onStateChange: this.handleStateChange,
        selectedItem: selectedItem
      }, function (_ref) {
        var getInputProps = _ref.getInputProps,
            getItemProps = _ref.getItemProps,
            isOpen = _ref.isOpen,
            highlightedIndex = _ref.highlightedIndex,
            openMenu = _ref.openMenu,
            closeMenu = _ref.closeMenu,
            selectedItem = _ref.selectedItem;

        var Input = _react["default"].createElement("div", {
          ref: _this2.inputWrapperRef,
          className: (0, _classnames["default"])(classes.root, className),
          onClick: _this2.onWrapperClick
        }, _react["default"].createElement("input", _extends({
          className: classes.input
        }, getInputProps(_objectSpread({
          ref: _this2.inputRef,
          onChange: _this2.onInputChange,
          onFocus: !isOpen ? openMenu : closeMenu,
          value: !isOpen ? selectedItem.label : inputValue
        }, inputProps)), {
          onBlur: function onBlur(selection) {
            return setFieldTouched(name, selection);
          }
        })), _react["default"].createElement("input", {
          type: "hidden",
          name: name,
          value: selectedItem.value
        }), _this2.renderArrowIcon(isOpen), selectedItem && selectedItem.value && _this2.renderTimesIcon(_this2.onItemSelect));

        var Dropdown = _react["default"].createElement("div", {
          className: classes.dropdown
        }, _this2.props.loading ? _react["default"].createElement("div", {
          className: classes.dropdownItem
        }, "Loading...") : null, items.filter(function (i) {
          return !inputValue || i.label.toLowerCase().includes(inputValue.toLowerCase());
        }).map(function (item, index) {
          var _classNames;

          return _react["default"].createElement("div", _extends({
            key: index,
            className: (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, classes.dropdownItem, true), _defineProperty(_classNames, classes.dropdownItemActive, highlightedIndex === index), _defineProperty(_classNames, classes.dropdownItemSelected, selectedItem === item), _classNames))
          }, getItemProps({
            index: index,
            item: item
          })), itemToString(item), item.note && _react["default"].createElement("span", {
            className: classes.dropdownItemNote
          }, item.note));
        }));

        return withScaffold ? _react["default"].createElement("div", null, _react["default"].createElement(_Scaffold["default"], {
          label: label,
          error: (0, _get["default"])(touched, name) && (0, _get["default"])(errors, name)
        }, Input, isOpen && Dropdown)) : _react["default"].createElement("div", null, Input, isOpen && Dropdown);
      });
    }
  }]);

  return Select;
}(_react.Component);

var styles = function styles(theme) {
  return {
    root: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "flex-start",
      alignItems: "center",
      width: "100%",
      minHeight: "40px",
      backgroundColor: theme.colors.white,
      border: "1px solid ".concat(theme.colors.gray300),
      padding: "0 12px",
      cursor: function cursor(props) {
        return props.disabled ? "not-allowed" : "default";
      }
    },
    input: {
      width: "calc(100% - 72px)",
      flexGrow: "1",
      color: "inherit",
      fontFamily: "inherit",
      fontWeight: "400",
      fontSize: "16px",
      lineHeight: "20px",
      border: "none",
      outline: "none",
      cursor: "inherit",
      boxShadow: "none",
      // Reset default inputs for mozilla
      "-webkit-appearance": "none",
      // Reset default browser styles
      "-moz-appearance": "none" // Reset default browser styles

    },
    arrow: {
      flexShrink: "0",
      display: "inline-flex",
      marginLeft: "auto"
    },
    dropdown: {
      position: "absolute",
      zIndex: theme.zIndex["selectDropdown"],
      width: "100%",
      maxHeight: "200px",
      cursor: "default",
      backgroundColor: theme.colors.white,
      border: "1px solid ".concat(theme.colors.gray300),
      boxShadow: theme.globalBoxShadow,
      // Add back focus style
      marginTop: "-1px",
      // force overlapping border with input
      overflowY: "scroll",
      WebkitOverflowScrolling: "touch"
    },
    dropdownItem: {
      fontSize: "16px",
      lineHeight: "20px",
      fontWeight: "400",
      padding: "8px 12px"
    },
    dropdownItemNote: {
      fontSize: "14px",
      position: "absolute",
      right: "10px",
      color: theme.colors.gray400
    },
    dropdownItemActive: {
      backgroundColor: theme.colors.gray100
    },
    dropdownItemSelected: {
      backgroundColor: theme.colors.gray200
    }
  };
};

var _default = (0, _withStyles["default"])(styles, {
  name: "EuiSelect"
})(Select);

exports["default"] = _default;